import axios from 'axios';
import { loginreq, req,reqs,upload,exports} from './axiosFun';

export const captcha = (params) => { return axios.get("https://aae-api.scszsj.com/v1/auth/captcha").then(res => res.data) };
// 登录接口
export const login = (params) => { return loginreq("post", "/v1/auth/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

export const adminu = () => { return req("get", "/v1/auth/me")};


export const loginout = () => { return req("post", "/v1/auth/logout") };


// 知识库管理
//  知识库管理-初始化
export const knowledgeInit = () => { return req("post", "/v1/knowledge/init") };
// 知识库管理-获取知识库列表
export const knowledgeList = (params) => { return reqs("get", "/v1/knowledge/list", params) };
// 知识库管理-获取知识库列表
export const knowledgeGet = (params) => {
  // 从params中提取roleId
  // const data = JSON.parse(params);
  const roleId = params;
  return req("get", `/v1/knowledge/${roleId}`)
};
//上传
export const knowledgeUpload = (id, params, onUploadProgress) => {
  // 从params中提取roleId
  //  const data = JSON.parse(params);
  // const roleId = data.kb_id;
  return upload("post", `/v1/knowledge/upload?kb_id=${id}`, params, {
    onUploadProgress,
    returnResponse: true
  })
};
// export const knowledgeUpload = (params) => { return req("post", "/v1/knowledge/upload", params) };
//新增
export const knowledgeCreate = (params) => { return req("post", "/v1/knowledge/create", params) };
//修改
export const knowledgeSave = (params) => {
    // 从params中提取roleId
    const data = JSON.parse(params);
    const roleId = data.id;
    return req("put", `/v1/knowledge/${roleId}`, params)
  };
  //改状态
  export const knowledgeSavestatus= (params) => {
    // 从params中提取roleId
    console.log(params,222222222222);
    const data = JSON.parse(params);
    const roleId = data.kb_id;
    console.log(roleId,333333);
    return req("put", `/v1/knowledge/${roleId}/status`, params)
  };
  //删除
export const knowledgefD = (params) => { return req("delete", "/v1/knowledge/file",params).then(res => res.data)};
export const knowledgeDeleteFile = (params) => {
  return req("delete", "/v1/knowledge/file", params, { returnResponse: true })
};


// 大模型配置
export const modelInit = (params) => {
  const MId = 1;
  return req("get", `/v1/llm/${MId}`)
};
export const modelInitput = (params) => {
  // 从params中提取roleId
  // const data = JSON.parse(params);
  const MId = 1;
  return req("put", `/v1/llm/${MId}`, params)
};

// 策略配置
export const policyInit = () => {
  // const MId = 1;
  return req("get", `/v1/policy/default`)
};
export const policyInitput = (params) => {
  return req("put", `/v1/policy/default`, params)
};

// chatAPI
export const chatAPIList = (params) => { return reqs("get", "/v1/chat-api/list", params) };

//chatAPI改状态
  export const chatAPISavestatus= (params) => {
    // 从params中提取roleId
    const data = JSON.parse(params);
    const roleId = data.kb_id;
    return req("put", `/v1/chat-api/${roleId}/status`, params)
  };
export const chatAPICreate = (params) => { return req("post", "/v1/chat-api", params) };
//修改
export const chatAPISave = (params) => {
  // 从params中提取roleId
  const data = JSON.parse(params);
  const roleId = data.id;
  return req("put", `/v1/chat-api/${roleId}`, params)
};
// chat_bot /v1/chat-bot
export const chatBOTList = (params) => { return reqs("get", "/v1/chat-bot", params) };

//chatBOT改状态
export const chatBOTSavestatus= (params) => {
  // 从params中提取roleId
  const data = JSON.parse(params);
  const roleId = data.chat_bot_id;
  return req("put", `/v1/chat-bot/${roleId}/status`, params)
};
//修改
export const chatBOTSave = (params) => {
  // 从params中提取roleId
  const data = JSON.parse(params);
  const roleId = data.id;
  return req("put", `/v1/chat-bot/${roleId}`, params)
};

export const chatBOTGet = (params) => {
  // 从params中提取roleId
  // const data = JSON.parse(params);
  const Id = params;
  return req("get", `/v1/chat-bot/${Id}`)
};
export const chatBOTCreate = (params) => { return req("post", "/v1/chat-bot", params) };
// oss上传
export const ossUpload = (params) => { return req("get", "/v1/upload/oss/signature",params)};

// 请求记录
export const questList = (params) => { return reqs("get", "/v1/request-log", params) };
export const questGet = (params) => {
  // 从params中提取roleId
  // const data = JSON.parse(params);
  const Id = params;
  return req("get", `/v1/request-log/${Id}`)
};
// 优化后的questExport方法
export const questExport = (params) => {
  return axios({
    method: 'get',
    url: "/v1/request-log/export",
    headers: {
      'Authorization': localStorage.getItem('logintoken')
    },
    params: params,
    responseType: 'blob' // 关键配置，必须放在这里
  })
  .then(res => {
    // console.log(res,222);
    // // 直接返回文件流，由调用方处理下载逻辑
    // downloadExcel(res);
    return res;
  })
  .catch(error => {
    // 统一错误处理
    const errorMsg = error.response ? error.response.data : '请求失败，请检查网络或参数';
    return Promise.reject(errorMsg);
  });
};
//export const questExport = (params) => { return axios.get("/v1/request-log/export",params).then(res => res) };

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return reqs("get", "/v1/roles/", params) };
// 角色管理-保存（添加）
export const roleSave = (params) => {
  // 从params中提取roleId
  const data = JSON.parse(params);
  const roleId = data.role_id;
  return req("put", `/v1/roles/${roleId}`, params)
};

// 角色管理-保存（添加）
export const roleadd = (params) => { return req("post", "/v1/roles/", params) };

// 角色管理-删除角色
export const roleDelete = (params) => { return req("delete", "/v1/roles/"+ params).then(res => res.data)};
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js